import MDBox from 'components/MDBox'
import React from 'react'
import CreateLinkModal from '../CreateLinkModal'
import { Grid } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import { useEffect } from 'react'
import { useState } from 'react'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'

const index = ({ data, handleChange }) => {
  const Service = useAppServices()
  const [tableData, setTableData] = useState([])
  const columns = [
    {
      name: 'Name',  // Fixed typo: changed 'page' to 'name'
      options: {
        filter: false,
      },
    },
    {
      name: 'Type',  // Fixed typo: changed 'type' to 'name'
      options: {
        filter: false,
      },
    },
    {
      name: 'Action',
      options: {
        filter: false,
      },
    },
  ]

  const options = {
    filter: false,
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: 'none',
    filterType: 'multiselect',
    responsive: 'standard',
  }

  const handleDelete = async (index) => {
    const agency_pages = data?.agency_pages
    if (index > -1) {
      agency_pages.splice(index, 1)
    }
    const payload = {
      agency_pages: agency_pages,
      _id: data._id,
    }
    const { response } = await Service.snapshot_onboarding.update({ payload })
    if (response) {
      handleChange()
    }
  }

  const onLoad = () => {
    const uniqueEntries = new Map();
    const tabel_data = [];
    
    data?.agency_pages?.forEach((element, index) => {
      // Create a unique key for each entry (combine page and linkType)
      const entryKey = `${element.page}_${element.linkType}`;
      
      // Only add to table if not already present
      if (!uniqueEntries.has(entryKey)) {
        uniqueEntries.set(entryKey, true);
        
        const temp = [
          element.page,
          element.linkType,
          <>
            <CreateLinkModal
              data={data}
              handleChange={handleChange}
              type="agency"
              editData={element}
              DataIndex={index}
            />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: '4px' }}
              onClick={() => handleDelete(index)}
            >
              Delete
            </MDButton>
          </>,
        ];
        tabel_data.push(temp);
      }
    });
    
    setTableData(tabel_data);
  }

  useEffect(() => {
    onLoad();
  }, [data]);

  return (
    <MDBox>
      <MDBox display="flex" justifyContent="flex-end" mb={3}>
        <CreateLinkModal data={data} handleChange={handleChange} type="agency" />
      </MDBox>
      <Grid item xs={12}>
        <MUIDataTable title={'Links'} data={tableData} columns={columns} options={options} />
      </Grid>
    </MDBox>
  )
}

export default index